export default "__VITE_PUBLIC_ASSET__198ccd81__"